export const getPopulatedSchema = (ads, domain) => {
    return {
        '@context': 'https://schema.org',
        '@type': ['SearchResultsPage', 'ItemList'],
        itemListElement: ads.map((ad, index) => {
            return {
                '@type': 'ListItem',
                position: index,
                url: `https://${domain}${ad.path}`,
                name: ad.title,
            };
        }),
    };
};

export const getProductSchema = (product) => {
    if (!product) return null;
    const { name, description, image = [], lowPrice, highPrice } = product;
    return {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: name,
        image: image,
        description: description,
        offers: {
            '@type': 'AggregateOffer',
            lowPrice: lowPrice,
            highPrice: highPrice,
            priceCurrency: 'GBP',
            // offerCount: 1497,
        },
    };
};
